import React from 'react'; // TODO: check

var context = React.createContext(null);
context.displayName = 'NavbarContext';
export default context;